// extracted by mini-css-extract-plugin
module.exports = {"BuilderImage":"BuilderImage_BuilderImage__8yNOk","mobileImage":"BuilderImage_mobileImage__dKyEW"};